import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import type {IndustryCategoriesReturnValueType} from '../../../core/repositories/reportsRepository';
import {getIndustryCategories} from '../../../core/repositories/reportsRepository';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../../core/repositories/usersMeRepository';
import {validateCookie} from '../../../core/usecases/auth/checkOauthTokenExistence';
import {FollowRankingPage} from '../../../features/company/components/FollowRankingPage';
import {withHandler} from '../../../server/token/withHandler';
import {ScriptForGA} from '../../../shared/components/ScriptForGA';
import {NoLeftSidebarLayout} from '../../../shared/components/layouts/NoLeftSidebarLayout';
import type {NextPageWithLayout} from '../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
  industryCategories?: IndustryCategoriesReturnValueType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>(
  {auth: 'optional'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const props: Props = {};
    const industryCategoriesData = await getIndustryCategories({});
    if (!industryCategoriesData.ok) {
      return {
        props,
      };
    }

    const {cookies} = context.req;
    const {isValid} = validateCookie(cookies);
    if (!isValid)
      return {
        props: {
          ...props,
          industryCategories: industryCategoriesData,
        },
      };

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {
          ...props,
          industryCategories: industryCategoriesData,
        },
      };
    }

    return {
      props: {
        ...props,
        industryCategories: industryCategoriesData,
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

const Page: NextPageWithLayout<Props> = ({
  userDataForAnalytics,
  industryCategories,
}: Props) => {
  return (
    <>
      <FollowRankingPage industryCategories={industryCategories} />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

Page.getLayout = (page) => <NoLeftSidebarLayout>{page}</NoLeftSidebarLayout>;

export default Page;
